/* Arrow icons: swaps arrow characters (for example the ones typed into button labels) for inline SVG,
   so they look the same on every device. Some phones draw characters like the diagonal arrow with
   the emoji font; an inline SVG always follows the text colour and weight. */
(() => {
  const P = {
    '↗': 'M6 14 14 6M7.5 6H14v6.5',      // up-right
    '↘': 'M6 6l8 8M14 7.5V14H7.5',         // down-right
    '↖': 'M14 14 6 6M12.5 6H6v6.5',        // up-left
    '↙': 'M14 6l-8 8M6 7.5V14h6.5',        // down-left
    '↓': 'M10 4v12M5 11l5 5 5-5',          // down
    '↑': 'M10 16V4M5 9l5-5 5 5',           // up
    '→': 'M4 10h12M11 5l5 5-5 5',          // right
    '←': 'M16 10H4M9 5l-5 5 5 5',          // left
    '↔': 'M3 10h14M7 6l-4 4 4 4M13 6l4 4-4 4', // left-right
    '✕': 'M5 5l10 10M15 5 5 15',           // close
  };
  const RE = /[↗↘↖↙↓↑→←↔✕]︎?️?/;
  const RE_G = new RegExp(RE.source, 'g');
  const SKIP = 'script,style,textarea,input,select,code,pre,svg,[data-mg-no-arrows],[class*="klaviyo"]';

  const svg = (d) => {
    const ns = 'http://www.w3.org/2000/svg';
    const s = document.createElementNS(ns, 'svg');
    s.setAttribute('class', 'mg-arrow');
    s.setAttribute('viewBox', '0 0 20 20');
    s.setAttribute('aria-hidden', 'true');
    s.setAttribute('focusable', 'false');
    const p = document.createElementNS(ns, 'path');
    p.setAttribute('d', d);
    s.appendChild(p);
    return s;
  };

  const fixText = (node) => {
    const text = node.nodeValue;
    if (!RE.test(text)) return;
    const frag = document.createDocumentFragment();
    let last = 0;
    text.replace(RE_G, (m, idx) => {
      if (idx > last) frag.appendChild(document.createTextNode(text.slice(last, idx)));
      frag.appendChild(svg(P[m[0]]));
      last = idx + m.length;
      return m;
    });
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  };

  const walk = (root) => {
    if (!root) return;
    if (root.nodeType === 3) {
      if (root.parentElement && !root.parentElement.closest(SKIP)) fixText(root);
      return;
    }
    if (root.nodeType !== 1 || root.matches(SKIP) || root.closest(SKIP)) return;
    const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (RE.test(n.nodeValue) && !n.parentElement.closest(SKIP) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const hits = [];
    while (w.nextNode()) hits.push(w.currentNode);
    hits.forEach(fixText);
  };

  const start = () => {
    walk(document.body);
    new MutationObserver((muts) => {
      muts.forEach((m) => {
        m.addedNodes.forEach((n) => walk(n));
        if (m.type === 'characterData') walk(m.target);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
